/**
 * Since some configurations need to be match with specific themes,
 * we recommend to use the configuration that generated from demo.
 */

import { SIZES } from "components/ui/utils/constant";

export const themeConfig = {
  themeColor: "slate",
  direction: "ltr",
  mode: "light",
  primaryColorLevel: 800,
  cardBordered: true,
  panelExpand: false,
  controlSize: SIZES.MD,
  navMode: "themed",
  layout: {
    type: "modern",
    sideNavCollapse: true,
  },
};
